import { render, staticRenderFns } from "./MainNavigationDrawer.vue?vue&type=template&id=35a3838a&scoped=true&"
import script from "./MainNavigationDrawer.vue?vue&type=script&lang=js&"
export * from "./MainNavigationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigationDrawer.vue?vue&type=style&index=0&id=35a3838a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a3838a",
  null
  
)

export default component.exports